import 'whatwg-fetch';
import Constants from '../model/AppConfiguration';
import StatusCodes from '../model/StatusCodes';
import FlightsConverter from '../converter/FlightsConverter';
import IntFlightsConverter from '../converter/IntFlightsConverter';
import PrintConverter from '../converter/PrintConverter';
import ResponseError from './ResponseError';
import Request from './Request';
import convert from 'xml-js';

export default {
  getFlights,
  setFlights,
};

function getFlights (request, reservationId, passengerId) {
  // reservationId = reservationId || 0;
  reservationId = 43946;
  let currentMillis = new Date().getTime();
  let url = `${
    Constants.BASE_URL
  }?fuseaction=airres.${request}&timestamp=${currentMillis}&reservationid=${reservationId}`;
  if (passengerId) {
    url = `${
      Constants.BASE_URL
    }?fuseaction=airres.${request}&timestamp=${currentMillis}&reservationid=${reservationId}&Contact_ObjectID=${passengerId}`;
  }
  return fetch(url, Request.getBase())
    .then(response =>
      response
        .text()
        .then(response => {
          let responseData = convert.xml2json(response, { compact: true, spaces: 4 });

          responseData = JSON.parse(responseData);
          responseData = responseData ? responseData.result : responseData;

          let status =
            responseData && responseData.status && responseData.status._text ?
              parseInt(responseData.status._text, 10) :
              StatusCodes.UNKNOWN_ERROR;
          if (status === StatusCodes.UNKNOWN_ERROR) {
            return ResponseError.responseError(responseData);
          }

          return {
            status: status,
            data: FlightsConverter.flightsWireToInt(responseData.data),
          };
        })
        .catch(error => ResponseError.responseError(error))
    )
    .catch(error => ResponseError.responseError(error));
}

function setFlights (request, general, flights) {
  let convertedFlights = IntFlightsConverter.flightsIntToWire(request, general, flights);
  let reservationId = general && general.reservationId ? general.reservationId : 0;
  let currentMillis = new Date().getTime();
  let url = `${
    Constants.BASE_URL
  }?fuseaction=airres.ActionSwitch&timestamp=${currentMillis}&reservationid=${reservationId}`;
  let body = convert.json2xml(convertedFlights, { compact: true, spaces: 4 });

  return fetch(url, Request.postBase(body))
    .then(response =>
      response
        .text()
        .then(response => {
          let responseData = convert.xml2json(response, { compact: true, spaces: 4 });
          responseData = JSON.parse(responseData);
          responseData = responseData ? responseData.result : responseData;

          let status =
            responseData && responseData.status && responseData.status._text ?
              parseInt(responseData.status._text, 10) :
              StatusCodes.UNKNOWN_ERROR;
          if (status === StatusCodes.UNKNOWN_ERROR) {
            return ResponseError.responseError(responseData);
          }

          if (request === Constants.REQUEST.ACTION.PRINT) {
            return {
              status: status,
              data: PrintConverter.printWireToInt(responseData.data),
            };
          }

          return {
            status: status,
            data: FlightsConverter.flightsWireToInt(responseData.data),
          };
        })
        .catch(error => ResponseError.responseError(error))
    )
    .catch(error => ResponseError.responseError(error));
}



// WEBPACK FOOTER //
// ./src/remoting/FlightsRemoting.js